module.exports = __webpack_public_path__ + "static/media/logo.bb89bbd9.svg";